module.exports = __webpack_public_path__ + "img/Frame 1103hrp6.21d5552c.png";